import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

const buildQuery = ({
  query,
  dataType,
  filters,
  dateScope,
}: {
  query: string;
  dataType: string;
  filters: FilterInput[];
  dateScope: DateRangeInput;
}) => ({
  query: gql`
      query CountRecords(
          $dataType: String!
          $filters: [FilterInput]!
          $dateScope: [DateRangeInput!]!
      ) {
          ${query} (
          dataType: $dataType
          filters: $filters
          dateScope: $dateScope
          )
      }
  `,
  variables: {
    dataType,
    filters,
    dateScope,
  },
});

const getGridRowCount = async ({
  query,
  dataType,
  filters,
  client,
  dateScope,
}: {
  query: string;
  dataType: string;
  filters: FilterInput[];
  client: ApolloClient<NormalizedCacheObject>;
  dateScope: DateRangeInput;
}) => {
  const gqlQuery = buildQuery({
    query,
    dataType,
    filters,
    dateScope,
  });
  const response = await client.query(gqlQuery);
  return response.data[query];
};

export default getGridRowCount;
